import { store } from '../../../../../../../../../store';
import { getExceptionsTypes, getProviderFormService } from '../../../helper';

export default (serviceData) => {
  if (serviceData?.form) {
    const { mode, service_type } = serviceData.form;
    if (mode === 0) {
      const state = store.getState();
      if (state?.services?.serviceTypes) {
        const { serviceTypes } = state.services;
        const findService = serviceTypes.find((type) => Number(type.id) === Number(service_type));
        if (findService) {
          return findService.minmax;
        }
      }
    }
    if (mode === 1) {
      const { provider_service_id } = serviceData.form;
      if (provider_service_id && serviceData?.providerForm) {
        const providerService = getProviderFormService(provider_service_id, serviceData.providerForm);
        const exceptionTypes = getExceptionsTypes()
        const isServiceExceptionType = exceptionTypes.includes(providerService?.service_type);
        if (isServiceExceptionType) {
          return false;
        }
      }
    }
  }
  return true;
};
